var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { EnvironmentService, HttpCacheType, HttpMethodType, HttpContentType } from "../../common";
import { API_PREFIX } from '../constants/BrandedNotificationConstant';
export class BrandedNotificationSaveService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    postBrandedNotificationConfiguration(brandedNotificationSaveUpdateRequest, coCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const RequestHttpMethodType = brandedNotificationSaveUpdateRequest.data.profileId
                ? HttpMethodType.PUT
                : HttpMethodType.POST;
            const uri = `${EnvironmentService.getEnvironment().apdApiGatewayRoot}${API_PREFIX}${coCode}/notification-themes`;
            const request = new Request(uri, {
                method: RequestHttpMethodType,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    'Content-Type': HttpContentType.APPLICATION_JSON,
                    accept: HttpContentType.APPLICATION_JSON,
                    Pragma: HttpCacheType.NO_CACHE
                }),
                body: JSON.stringify(brandedNotificationSaveUpdateRequest)
            });
            return this.fetchWrapper(request)
                .then(response => response.json())
                .then(response => {
                return Promise.resolve(response.result);
            });
        });
    }
}
//# sourceMappingURL=BrandedNotificationSaveService.js.map